import { FETCH_SAVED_SALES_REPORT } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const savedSalesTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SAVED_SALES_REPORT:
      return { data: action.payload };
    default:
      return state;
  }
};

export default savedSalesTemplateReducer;
